module.exports = __webpack_public_path__ + "img/jiangbei.8422ca5e.png";